<div class="sidebar">
  @for (section of menuSections; track $index) {
    <div class="menu-section">
      <h3 class="font-medium text-xl">{{ section.title }}</h3>
      <ul class="submenu my-2">
        @for (item of section.items; track trackByRoute($index, item)) {
          <li>
            <a
              routerLinkActive="active"
              [routerLink]="item.route"
            >
              {{ item.label }}
            </a>
          </li>
        }
      </ul>
    </div>
  }
</div>
